import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueLogger from 'vuejs-logger';

import App from './App.vue';
import router from './router';
import store from './store/store';

import '@/assets/css/tailwind.pcss';

const isProduction = process.env.NODE_ENV === 'production';

// Logger
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};
Vue.use(VueLogger, options);

Vue.config.productionTip = false;

if (process.env.VUE_APP_GA_ID) {
  Vue.$log.debug('Starting GA on ID=', process.env.VUE_APP_GA_ID);
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_ID,
    debug: {
      enabled: !isProduction,
    },
    router,
  });
} else {
  Vue.$log.debug('No GA');
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
